var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var colorsV1 = {
    white: '#FFFFFF',
    offWhite: '#FFFCF7',
    /* Cyan */
    cyan: '#0AA1DD',
    /* Green */
    greenDarkest: '#023E2A',
    greenDarker: '#004931',
    greenDark: '#006644',
    greenBase: '#008558',
    greenLight: '#3AAD86',
    greenLighter: '#A8E0CD',
    greenLightest: '#EBFCF6',
    /* Mist */
    mistDarkest: '#ABB8BA',
    mistDarker: '#C2CBCD',
    mistDark: '#C8D7D9',
    mistBase: '#DADDDD',
    mistLight: '#EBEBEB',
    mistLightest: '#F5F5F5',
    /* Orange */
    orangeDarker: '#C1570B',
    orangeLight: '#F7A76E',
    orangeLighter: '#FBD3B6',
    orangeLightest: '#FEF0E7',
    /* Rust */
    rustDarker: '#B42C10',
    rustBase: '#D64B2F',
    rustLight: '#F27F67',
    rustLighter: '#FFAF9E',
    rustLightest: '#FDF3F1',
    /* Slate */
    slateDarker: '#172D30',
    slateBase: '#3C5255',
    slateLight: '#59797D',
    slateLightest: '#84A5AA',
    /* Sky */
    skyBase: '#DFE9ED',
    /* Teal */
    tealDarkest: '#013941',
    tealDarker: '#00525E',
    tealDark: '#005A66',
    tealBase: '#007989',
    tealLight: '#43AAB8',
    tealLighter: '#AADBE1',
    tealLightest: '#F1F9F9',
    /* Yellow */
    yellowDarker: '#BE750E',
    yellowLight: '#F4BD71',
    yellowLighter: '#F8E3C6',
    yellowLightest: '#FFF7ED'
};
var legacy = __assign({}, colorsV1);
var colors = __assign(__assign({}, legacy), { legacy: legacy, white: '#FFFFFF', bigBangBlack: '#121212', cosmosCream: '#FFFCF7', blue0: '#F2F5FA', blue5: '#E5EFFF', blue10: '#D2E4FE', blue20: '#ACCCFD', blue30: '#85B4FB', blue40: '#5F9CF7', blue50: '#3A83F2', blue60: '#156AE9', blue70: '#0056D7', blue80: '#0045AD', blue90: '#002B6B', blue100: '#001433', green0: '#F4FAF8', green5: '#CDF5E8', green10: '#A4EBD3', green20: '#5CD6AF', green30: '#25C290', green40: '#00AD78', green50: '#00996D', green60: '#008561', green70: '#007054', green80: '#005C48', green90: '#00473A', green100: '#00332A', neutral0: '#F7F7F7', neutral5: '#EEF1F1', neutral10: '#E1E7E7', neutral20: '#C6D1D1', neutral30: '#ADBBBB', neutral40: '#94A5A5', neutral50: '#7D8F8F', neutral60: '#677979', neutral70: '#526363', neutral80: '#3E4D4D', neutral90: '#2B3737', neutral100: '#192121', orange0: '#FAF6F2', orange5: '#F9EBDB', orange10: '#F7DFC4', orange20: '#F4C896', orange30: '#EFAF69', orange40: '#E8953D', orange50: '#DC7913', orange60: '#B95C00', orange70: '#A04D00', orange80: '#7E3B00', orange90: '#542600', orange100: '#261100', pink: 'PLACEHOLDER', proximaGreen0: '#F9FFFD', proximaGreen5: '#E1FDF4', proximaGreen10: '#C9FAEC', proximaGreen20: '#9CF6DB', proximaGreen30: '#6FF1CA', proximaGreen40: '#45EDBA', proximaGreen50: '#1CE8AB', red0: '#FFFAF9', red5: '#FEE9E5', red10: '#FDD8D1', red20: '#F9B7AA', red30: '#F49582', red40: '#ED745B', red50: '#E15236', red60: '#CF3213', red70: '#B51E00', red80: '#911800', red90: '#641100', red100: '#330800', teal0: '#F4FAF9', teal5: '#DCF5F1', teal10: '#C2EAE6', teal20: '#91D5D2', teal30: '#66BFC0', teal40: '#42A6AB', teal50: '#248C96', teal60: '#0C7482', teal70: '#005E6D', teal80: '#004A58', teal90: '#003843', teal100: '#00262E', yellow0: '#FFFEF9', yellow5: '#FEF7D4', yellow10: '#FDF0B1', yellow20: '#F9E16B', yellow30: '#F5D22F', yellow40: '#EDC200', yellow50: '#E2B700', yellow60: '#AC8800', yellow70: '#8F6E00', yellow80: '#705300', yellow90: '#523A00', yellow100: '#382500' });
export default colors;
